import { Component, Input } from "@angular/core";
import { AuthUserService } from "@app/auth/services/auth-user.service";
import { RouterService } from "@app/root-store/router.service";

@Component({
    selector: "app-social-sign-in-block",
    templateUrl: "./social-sign-in-block.component.html",
    styleUrls: ["./social-sign-in-block.component.scss"],
})
export class SocialSignInBlockComponent {
    @Input() isStaff = false;

    constructor(private readonly authUserService: AuthUserService, private readonly routerService: RouterService) {}

    auth(provider: string): void {
        if (this.isStaff) {
            this.routerService.navigateToUrl([`/login/forgot-password`], { queryParamsHandling: "merge" });
        } else {
            this.authUserService.clearLoginErrorState();
            this.routerService.navigateToUrl([`/login/social/${provider}`], { queryParamsHandling: "merge" });
        }
    }
}
